import { render, staticRenderFns } from "./PencilIcon.vue?vue&type=template&id=4ac6522b&"
import script from "./PencilIcon.vue?vue&type=script&lang=ts&"
export * from "./PencilIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PencilIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports